<template>
    <span v-html="formattedTime"/>
</template>

<script>
export default {
    name: "TableCellTypeTime",
    props: {
        value: String,
        column: Object
    },
    computed: {
        step() {
            return parseFloat(this.column.step || '60')
        },
        formattedTime() {
            if (!this.value) return '';

            // Split Postgres time (HH:mm:ss.u)
            const [timePart, fractionalPart] = this.value.split('.');
            const [hours, minutes, seconds] = timePart.split(':');

            // 1. Milliseconds (Step is less than 1 second)
            if (this.step < 1) {
                const ms = fractionalPart ? fractionalPart.substring(0, 3).padEnd(3, '0') : '000';
                return `${hours}:${minutes}:${seconds}.${ms}`;
            }

            // 2. Seconds (Step is less than 60 seconds)
            if (this.step < 60) {
                return `${hours}:${minutes}:${seconds}`;
            }

            // 3. Minutes (Default / Step is 60 or greater)
            return `${hours}:${minutes}`;
        }
    }
}
</script>

<style scoped>

</style>